import styled from "styled-components";

const Container = styled.div`
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #333;
  margin: 8px 0 32px 0;
  font-weight: 600;
`;

const Subtitle = styled.p`
  font-size: 20px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 600;

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    font-size: 16px;
  }
`;

const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: 80vw;

    @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
        width: 100%;
    }
`;

const Card = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 34px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: transform 0.2s, box-shadow 0.2s;
  width: 21rem;
  gap: 1rem;
  opacity: ${props => (props.disabled ? '0.8' : '1')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  background-color: ${props =>
    props.disabled ? props.theme.colors.greys.disabledBackground : '#fff'};
      gap: 8px;
  flex: 1 1 calc((100% - 4rem) / 3);
  max-width: calc((100% - 4rem) / 3);

  &:hover {
    box-shadow: ${props => (props.disabled ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.05)')};
    border-color: #b0b0b0;
  }

    @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: flex-start;
      gap: 1rem;
      padding: 24px;
      width: 100%;
      max-width: 100%;
      flex: 1 1 100%;
  }
`


const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardLabel = styled.span`
  color: #333;
  text-align: center;
  font-weight: 400;
  font-size: 18px;  
`;


const WaitLabel = styled.div`
  color: #525252;
  text-align: center;
  font-weight: 500;

    @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
      margin: 0.5rem 0;
      text-align: start;
    }
`;

const Bold = styled.span`
font-weight: 600;
`;

const BackTitle = styled.p`
  color: ${props => props.theme.colors.brand.blueOmint};
	text-decoration: underline;
	font-size: 16px;
	font-weight: 600;
	display: flex;
	align-items: center;
	gap: 8px;
  cursor: pointer;
  margin: ${({ m }) => m || '0 0 24px 0'};

	&:hover {
		text-decoration: underline;
	}

	span {
		font-size: 18px;
	}

  @media (min-width: ${props => props.theme.sizes.breakPoints.mobile}) {
    display: none; 
  }
`

export {
  Container,
  Title,
  Subtitle,
  Grid,
  Card,
  IconWrapper,
  CardLabel,
  WaitLabel,
  Bold,
  BackTitle
}